import MuiTextField from '@material-ui/core/TextField';
import { fieldToTextField, TextFieldProps } from 'formik-material-ui';
import * as React from 'react';
import { useIntl } from 'react-intl';

export default function NumberFormatTextField(props: TextFieldProps) {
  const { formatNumber } = useIntl();
  const {
    form: { setFieldValue },
    field: { name },
  } = props;

  const onChange = React.useCallback(
    (event) => {
      const { value } = event.target;
      const formatted = formatNumber(value.replace(/,/g, ''));
      setFieldValue(name, formatted !== 'NaN' ? formatted : value);
    },
    [setFieldValue, name, formatNumber],
  );

  return (
    <MuiTextField
      {...fieldToTextField(props)}
      onChange={onChange}
      inputProps={{ inputMode: 'numeric' }}
    />
  );
}
